import { Site } from '@envato/foundation-types'

const experimentConfig = {
  categoryPageCuratedItemsBlockGR: {
    experimentId: 'goEF7M94S12cAEcozNNhdg',
    running: true,
    loadingCover: true,
    sites: [Site.graphicriver],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true
      },
      3: {
        categoryPageBlocksB: true
      }
    }
  },
  homepageNewDesignGlobal: {
    experimentId: 'gKIzsB-zQ_CEXG-jI-AyGQ',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    variantsWeights: [1, 9],
    variants: {
      0: {
        homepageNewDesignGlobal: false
      },
      1: {
        homepageNewDesignGlobal: true
      }
    }
  },
  homepageNewDesign: {
    experimentId: 'BkkvtMQPQP2alGvi8MQrDA',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    requires: {
      homepageNewDesignGlobal: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: false
      },
      1: {
        homepageNewDesign: true
      }
    }
  }
}

export default experimentConfig
